<section class="service-page">
  <div class="row pad">
    <div class="service-page__inner">
      <h1>Privacy</h1>

      <p>
        To deliver experiences that move culture globally and provide you with
        exceptional sports, entertainment, art and lifestyle events, we need to
        process personal data. We are committed to processing personal data in a
        compliant and transparent manner. We take protecting personal data
        seriously.
      </p>

      <p>We have tailored our privacy notices to the audience:</p>

      <ul>
        <li>
          <a [routerLink]="['/mari-privacy-notice']"
            ><strong>MARI Privacy Notice</strong></a
          >
          for visitors to the MARI website (<a [routerLink]="['/']"
            >www.marigrp.com</a
          >), contractors to MARI group entities, and all others not covered by
          one of the privacy notices listed below (such as personnel of
          suppliers, vendors, business partners, and customers)
        </li>
        <li>
          <a [routerLink]="['/employee-privacy-notice']"
            ><strong>MARI Employee Privacy Notice</strong></a
          >
          for our employees
        </li>
        <li>
          <a [routerLink]="['/event-privacy-notices']"
            ><strong>Event Privacy Notices</strong></a
          >
          for event attendees. They can also be found on the website for each
          event.
        </li>
      </ul>

      <p>
        To exercise your privacy choices,
        <a
          [href]="privacyChoicesUrl"
          target="_blank"
          rel="noopener noreferrer"
          >use this link</a
        >. To change your cookie settings, navigate to the webpage for which you
        want to change your cookie settings, and select
        <button
          type="button"
          class="cookie-settings-link"
          (click)="openCookieSettings()"
        >
          “Cookie Settings”</button
        >.
      </p>
    </div>
  </div>
</section>
